export const LAYOUT_TYPE = {
  dashboard_desktop_card: 'dashboard_desktop_card',
  investing_slider_card: 'investing_slider_card',
  investing_offer_card: 'investing_offer_card',
};

export const INCREASED_INCOME_TYPES = {
  get_increased_income: 'get_increased_income',
  keep_benefiting_save_type_a: 'keep_benefiting_save_type_a',
  keep_benefiting_save_type_b: 'keep_benefiting_save_type_b',
  keep_benefiting_done_type_a: 'keep_benefiting_done_type_a',
  keep_benefiting_done_type_b: 'keep_benefiting_done_type_b',
  keep_benefiting_done_type_c: 'keep_benefiting_done_type_c',
};

export const INCREASED_INCOME_FEES = {
  [INCREASED_INCOME_TYPES.get_increased_income]: 0.75,
  [INCREASED_INCOME_TYPES.keep_benefiting_save_type_a]: 0.75,
  [INCREASED_INCOME_TYPES.keep_benefiting_save_type_b]: 0.75,
  [INCREASED_INCOME_TYPES.keep_benefiting_done_type_a]: 1,
  [INCREASED_INCOME_TYPES.keep_benefiting_done_type_b]: 1,
  [INCREASED_INCOME_TYPES.keep_benefiting_done_type_c]: 1,
};
